import React from 'react'
import UsersList from '../users-list'

const HomePage = () => {
  return (
    <div>
      <UsersList />
    </div>
  )
}

export default HomePage